import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAllCompositionExportsXmpMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllCompositionExportsXmpMetadataQuery = { __typename?: 'Query', getAllCompositionExportsXmpMetadata: Array<{ __typename?: 'CompositionExportsXMPMetadata', accountId: string, assetId: string, compositionId?: string | null, compositionName?: string | null, exportedAt: number, projectId: string, versionId?: string | null, workAreaStart?: number | null, workAreaDuration?: number | null }> };


export const GetAllCompositionExportsXmpMetadata = /*#__PURE__*/ gql`
    query GetAllCompositionExportsXmpMetadata {
  getAllCompositionExportsXmpMetadata {
    accountId
    assetId
    compositionId
    compositionName
    exportedAt
    projectId
    versionId
    workAreaStart
    workAreaDuration
  }
}
    ` as unknown as DocumentNode<GetAllCompositionExportsXmpMetadataQuery, GetAllCompositionExportsXmpMetadataQueryVariables>;

          

          export const useGetAllCompositionExportsXmpMetadataQuery = (options?:QueryHookOptions<GetAllCompositionExportsXmpMetadataQuery, GetAllCompositionExportsXmpMetadataQueryVariables>) => useQuery(GetAllCompositionExportsXmpMetadata, options);

          

          export type GetAllCompositionExportsXmpMetadataQueryOptions = QueryHookOptions<GetAllCompositionExportsXmpMetadataQuery, GetAllCompositionExportsXmpMetadataQueryVariables>;

          

          export const useGetAllCompositionExportsXmpMetadataLazyQuery = (options?:LazyQueryHookOptions<GetAllCompositionExportsXmpMetadataQuery, GetAllCompositionExportsXmpMetadataQueryVariables>) => useLazyQuery(GetAllCompositionExportsXmpMetadata, options);

          

          export type GetAllCompositionExportsXmpMetadataQueryResult = ReturnType<typeof useGetAllCompositionExportsXmpMetadataQuery>;

          
